function initFaq(container) {
  container.querySelectorAll('.faq-cstm__list').forEach(function (list) {
    list.querySelectorAll('.faq-cstm__item').forEach(function (item) {
      var summary = item.querySelector('.faq-cstm__question');
      if (!summary) return;

      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      item.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      });
    });

    list.addEventListener('click', function (e) {
      var clickedItem = e.target.closest('details.faq-cstm__item');
      if (!clickedItem) return;

      list.querySelectorAll('details.faq-cstm__item').forEach(function (item) {
        if (item !== clickedItem && item.open) item.open = false;
      });
    });
  });

  var searchInput = container.querySelector('[data-faq-search-input]');
  var filters = container.querySelectorAll('[data-faq-filter]');
  var empty = container.querySelector('[data-faq-empty]');
  var activeFilter = 'all';

  function normalizeText(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function updateResults() {
    var term = searchInput ? normalizeText(searchInput.value.trim()) : '';
    var visibleCount = 0;

    container.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var text = normalizeText(item.dataset.faqSearch || '');
      var category = item.dataset.faqCategory || '';
      var matchesTerm = !term || text.indexOf(term) !== -1;
      var matchesFilter = activeFilter === 'all' || category === activeFilter;
      var isVisible = matchesTerm && matchesFilter;

      item.hidden = !isVisible;
      if (!isVisible && item.open) item.open = false;
      if (isVisible) visibleCount += 1;
    });

    if (empty) empty.hidden = visibleCount > 0;
  }

  if (searchInput) {
    searchInput.addEventListener('input', updateResults);
  }

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      activeFilter = button.dataset.faqFilter || 'all';
      filters.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
      });
      updateResults();
    });
  });

  updateResults();
}

document.querySelectorAll('.faq-cstm').forEach(initFaq);

document.addEventListener('shopify:section:load', function (e) {
  var section = e.target.querySelector('.faq-cstm');
  if (section) initFaq(section);
});
